export enum ApiErrors {
    AddressUsedInOpenedProject = 'ADDRESS_USED_IN_OPENED_PROJECT',
    AddressUsedInClosedProject = 'ADDRESS_USED_IN_CLOSED_PROJECT',
    Generic = 'SOMETHING_WENT_WRONG',
    SFUnableToLockRow = 'SALESFORCE_API_ERROR_UNABLE_TO_LOCK_ROW'
}
